import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { PalletLocationService } from "src/services/pallets";
import { queryKeys } from "src/constants";

const usePalletLocations = (palletLocationService: PalletLocationService) => {
  const {
    data: locationsData,
    isLoading,
    error: fetchError,
    refetch: refreshLocations
  } = useQuery({
    queryKey: queryKeys.palletLocations(),
    queryFn: () => palletLocationService.getPalletLocations()
  });

  const locations = useMemo(
    () => (locationsData ?? []).slice().sort((a, b) => a.position - b.position),
    [locationsData]
  );

  const openLocations = useMemo(() => locations.filter((l) => l.status === "OPEN"), [locations]);

  return {
    locations,
    openLocations,
    isLoading,
    fetchError,
    refreshLocations
  };
};

export { usePalletLocations };
